import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matchipautocomp',
	templateUrl:'./MatChipAutoCompletePage.html',
	styles: [],
	styleUrls:['./MatChipAutoCompletePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatChipAutoCompletePage
{
	mdContent_247 = `\`\`\`java
import com.jwebmp.plugins.angular.material.chips.MatChipAutoComplete;
\`\`\``;
	mdContent_248 = `\`\`\`java
MatChipAutoComplete()
\`\`\``;
	mdContent_249 = `\`\`\`java
MatChipAutoComplete&lt;?&gt; chips = new MatChipAutoComplete&lt;&gt;();
chips.setPlaceholder("Add tags...");
chips.addOption("Angular");
chips.addOption("React");
chips.setRemovable(true);
\`\`\``;
}
